const compileSyndicationsAppearancesCoverage = ( syndications = [], appearances = [], coverage = [] ) => {

  let countries = [];
  let countOutlets = 0;
  let languages = [];
  let countLanguages = 0;

  const compileCountries = (countries, items ) => {
    items.forEach((item) => {
      item?.outlet?.country && countries.push(item.outlet.country );
      item?.language && languages.push(item.language);
    })
  }
  compileCountries(countries, syndications );
  compileCountries(countries, appearances );
  compileCountries(countries, coverage );
  

  countries = countries.filter(( value, index, self) => 
    index === self.findIndex((t) => (
      t.id === value.id
    ))
  );

  languages = languages.filter(( value, index, self) => 
    index === self.findIndex((t) => (
      t.id === value.id
    ))
  );

  countLanguages = languages.length;

  const addOutletsToCountry = (country, items) => {
    items.forEach((item) => {
      if ( item?.outlet?.country?.id === country.id ) {
        country.outlets.push( item.outlet )
      }
    });
  };

  countries.forEach(( country ) => {
    if ( ! country.outlets ) country.outlets = [];
    addOutletsToCountry(country, syndications);
    addOutletsToCountry(country, coverage);
    addOutletsToCountry(country, appearances);
    country.outlets = country.outlets.filter(( value, index, self) => 
      index === self.findIndex((t) => (
        t.id === value.id
      ))
    );
    countOutlets += country.outlets.length;
  });

  const addItemsToOutlet = (outlet, items) => {
    items.forEach((item) => {
      if ( item?.outlet?.id === outlet.id ) {
        outlet.items.push( item );
      }
    });
    outlet.items = outlet.items.filter(( value, index, self) => 
      index === self.findIndex((t) => (
        t.id === value.id
      ))
    );
  };

  countries.forEach(( country ) => {
    let itemsCount = 0;
    country.outlets.forEach(( outlet ) => {
      if ( ! outlet.items ) outlet.items = [];
      addItemsToOutlet( outlet, syndications );
      addItemsToOutlet( outlet, coverage );
      addItemsToOutlet( outlet, appearances );
      itemsCount += outlet.items.length;
    });
    country.outlets.sort((a, b) => {
      return a.sort - b.sort;
    });
    country.count = itemsCount;
  });

  countries.sort((a, b) => {
    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  });

  countries.sort((a, b) => {
    return b.outlets.length - a.outlets.length;
  });

  return {
    countries: countries,
    countCountries: countries.length,
    countOutlets: countOutlets,
    countLanguages: countLanguages
  }
};

export default compileSyndicationsAppearancesCoverage;